import React from "react";
import { useBreadcrumbs } from "app/breadcrumbs/hooks";
import { Breadcrumbs } from "app/breadcrumbs/Breadcrumbs/Breadcrumbs";

export interface Props {
    /**
     * A string to be shown as the final item of the breadcrumb list.
     */
    finalLabel?: string;
}

export const BreadcrumbsContainer = ({finalLabel}: Props) => {
    return <Breadcrumbs items={useBreadcrumbs(finalLabel)} />
};
